function _instanceof(left, right) {
  return null != right && "undefined" != typeof Symbol && right[Symbol.hasInstance] ? right[Symbol.hasInstance](left) : left instanceof right;
}

function _typeof(obj) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) {
    descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}

function _possibleConstructorReturn(self, call) {
  return call && ("object" === _typeof(call) || "function" == typeof call) ? call : _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: !0,
      configurable: !0
    }
  }), superClass && _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf || function (o, p) {
    return o.__proto__ = p, o;
  }, _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}

import { createElement } from "react";
import PropTypes from "prop-types";
import BaseControl from "./base-control";
import MapState from "../utils/map-state";
import TransitionManager from "../utils/transition-manager";
import deprecateWarn from "../utils/deprecate-warn";

var LINEAR_TRANSITION_PROPS = Object.assign({}, TransitionManager.defaultProps, {
  transitionDuration: 300
}),
    propTypes = Object.assign({}, BaseControl.propTypes, {
  className: PropTypes.string,
  onViewStateChange: PropTypes.func,
  onViewportChange: PropTypes.func,
  showCompass: PropTypes.bool,
  showZoom: PropTypes.bool
}),
    defaultProps = Object.assign({}, BaseControl.defaultProps, {
  className: "",
  onViewStateChange: function onViewStateChange() {},
  onViewportChange: function onViewportChange() {},
  showCompass: !0,
  showZoom: !0
}),
    NavigationControl = function (_BaseControl) {
  function NavigationControl(props) {
    var _this;

    return _classCallCheck(this, NavigationControl), _this = _possibleConstructorReturn(this, (NavigationControl.__proto__ || Object.getPrototypeOf(NavigationControl)).call(this, props)), deprecateWarn(props), _this._updateViewport = _this._updateViewport.bind(_assertThisInitialized(_this)), _this._onZoomIn = _this._onZoomIn.bind(_assertThisInitialized(_this)), _this._onZoomOut = _this._onZoomOut.bind(_assertThisInitialized(_this)), _this._onResetNorth = _this._onResetNorth.bind(_assertThisInitialized(_this)), _this._renderCompass = _this._renderCompass.bind(_assertThisInitialized(_this)), _this._renderButton = _this._renderButton.bind(_assertThisInitialized(_this)), _this;
  }

  return _inherits(NavigationControl, _BaseControl), _createClass(NavigationControl, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return this.context.viewport.bearing !== nextContext.viewport.bearing;
    }
  }, {
    key: "_updateViewport",
    value: function _updateViewport(opts) {
      var viewport = this.context.viewport,
          mapState = new MapState(Object.assign({}, viewport, opts)),
          viewState = Object.assign({}, mapState.getViewportProps(), LINEAR_TRANSITION_PROPS);
      this.props.onViewStateChange({
        viewState: viewState
      });
      var onViewportChange = this.props.onChangeViewport || this.props.onViewportChange;
      onViewportChange(viewState);
    }
  }, {
    key: "_onZoomIn",
    value: function _onZoomIn() {
      this._updateViewport({
        zoom: this.context.viewport.zoom + 1
      });
    }
  }, {
    key: "_onZoomOut",
    value: function _onZoomOut() {
      this._updateViewport({
        zoom: this.context.viewport.zoom - 1
      });
    }
  }, {
    key: "_onResetNorth",
    value: function _onResetNorth() {
      this._updateViewport({
        bearing: 0,
        pitch: 0
      });
    }
  }, {
    key: "_renderCompass",
    value: function _renderCompass() {
      var bearing = this.context.viewport.bearing;
      return createElement("span", {
        className: "mapboxgl-ctrl-compass-arrow",
        style: {
          transform: "rotate(".concat(bearing, "deg)")
        }
      });
    }
  }, {
    key: "_renderButton",
    value: function _renderButton(type, label, callback, children) {
      return createElement("button", {
        key: type,
        className: "mapboxgl-ctrl-icon mapboxgl-ctrl-".concat(type),
        type: "button",
        title: label,
        onClick: callback,
        children: children
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          showCompass = _this$props.showCompass,
          showZoom = _this$props.showZoom;
      return createElement("div", {
        className: "mapboxgl-ctrl mapboxgl-ctrl-group ".concat(className),
        ref: this._onContainerLoad
      }, [showZoom && this._renderButton("zoom-in", "Zoom In", this._onZoomIn), showZoom && this._renderButton("zoom-out", "Zoom Out", this._onZoomOut), showCompass && this._renderButton("compass", "Reset North", this._onResetNorth, this._renderCompass())]);
    }
  }]), NavigationControl;
}(BaseControl);

export { NavigationControl as default };
NavigationControl.displayName = "NavigationControl", NavigationControl.propTypes = propTypes, NavigationControl.defaultProps = defaultProps;